module.exports = __webpack_public_path__ + "static/media/flowers.cfa43460.png";